import React, { Component } from 'react';
import { Formik, Form } from 'formik';
import { ErrorMessage, ZipField, MaskedField, Label } from '../FormikCustom';
import getAddressValidator from './Step2Validator';

import Spinner from '../Spinner/Spinner';
import { api } from '../../api/client';
import userService from '../../api/userService';

export default class AddressStep extends Component {
  constructor(props) {
    super(props);
    this.form3Refs = React.createRef();

    this.onSubmitHandler = this.onSubmitHandler.bind(this);
    this.state = {
      serverError: '',
      states: [],
      isSubmitted: false,
    };
  }
  async componentDidMount() {
    window.scroll(0, 0);
    try {
      const response = await api.get('states');

      const states = response.data.map((s) => {
        return { value: s.Code, label: s.Name };
      });

      this.setState({ states });
      this.setState({ topics: states });
    } catch (error) {
      this.state.set({ serverError: 'something went wrong' });
      console.log(error);
    }
  }

  parseValidationResponse(result) {
    const errorMessages = [];
    if (!result.data) {
      errorMessages.push('Something went wrong');
      return errorMessages;
    }

    if (!result.data.IsAddressValid) {
      errorMessages.push('Address is not valid');
    }
    if (result.data.IsSsnRequired && !result.data.IsSsnValid) {
      errorMessages.push('SSN is not valid');
    }

    return errorMessages;
  }

  async validateOnServer(accountNumber, ssn, address) {
    const me = this;
    this.setState({ loading: true });
    try {
      const result = await userService.checkAccountDetails(accountNumber, ssn, address);

      this.setState({ loading: false });
      if (result.data.IsValid) {
        this.setState({ serverErrors: [], accountIsValid: true });

        return Promise.resolve(true);
      } else {
        const errorMessages = me.parseValidationResponse(result);
        this.setState({ serverErrors: errorMessages, accountIsValid: false });
        return Promise.reject(errorMessages);
      }
    } catch (e) {
      this.setState({
        loading: false,
        serverErrors: [e.message],
      });
      return Promise.reject(e);
    }
  }

  async submitFormData(values) {

    if (this.state.isSubmitted) return;
    this.setState({ loading: true });
    const formData = {
      ...values,
      ...this.props.data,
    };
    const payload = {
      User: {
        UserName: formData.email,
        Password: formData.password,
        FirstName: formData.firstName,
        LastName: formData.lastName,
      },
      Account: {
        AccountNumber: this.props.accountNumber,
        SocialSecurityNumber: formData.ssn,
        Address: {
          ZipCode: formData.zip,
        },
      },
    };

    try {
      const url = 'users/' + this.props.userId + '/accounts';
      const result = await api.post(url, payload);
      this.setState({ loading: false });

      if (result.status === 200) {
        this.setState({ serverErrors: [], isSubmitted: true });
        return Promise.resolve(true);
      } else {
        const errorMessages = result.data;
        this.setState({ serverErrors: errorMessages, isSubmitted: false });
        return Promise.reject(errorMessages);
      }
    } catch (error) {
      this.setState({
        loading: false,
        serverErrors: [error.message],
      });
      return Promise.reject(error);
    }
  }

  isValidated() {
    const me = this;
    const form = this.form3Refs.current;
    const actions = form.getFormikActions();
    const values = form.getFormikBag().values;

    const ssn = values.ssn;
    const payload = {
      ...values,
    };
    delete payload.ssn;

    return actions.validateForm().then(async (result) => {
      if (Object.keys(result).length === 0) {
        try {
          await this.validateOnServer(me.props.accountNumber, ssn, payload);
          await me.submitFormData(values);

          this.props.onAccountCreated();
          actions.submitForm();

          return Promise.resolve(true);
        } catch (e) {
          console.log('account validation failed: ', e);
          return Promise.reject(); //If reject returns other than undefined or false Stepzilla will give exception!
        }
      } else {
        await actions.submitForm();
        return Promise.reject();
      }
    });
  }

  onSubmitHandler(values) {
    this.props.onSubmited(2, values);
  }

  render() {
    const spinner = this.state.loading ? <Spinner /> : null;

    const serverErrorDiv =
      this.state.serverErrors && this.state.serverErrors.length > 0 ? (
        <div className="errorMessage">
          {this.state.serverErrors.map((s, i) => (
            <li key={i}>{s}</li>
          ))}
        </div>
      ) : null;

    let initValues = {
      zip: '',
      ssn: '',
      SSNRequired: this.props.requiredSSN ? true : false,
    };

    if (this.props.stepValues) {
      initValues = this.props.stepValues;
    }

    //const valueFromId = (opts, id) => opts.find(o => o.value === id);

    const schema = getAddressValidator(this.props.requiredSSN);

    return (
      <div>
        <p>
          For your account protection, please verify the <strong>billing information</strong> for this account.
        </p>
        <Formik
          ref={this.form3Refs}
          initialValues={initValues}
          validationSchema={schema}
          onSubmit={this.onSubmitHandler}
        >
          {() => (
            <Form className="registerUserForm">
              <div className="form-group">
                <Label htmlFor="zip">Zip</Label>

                <ZipField className="form-control" name="zip" />

                <ErrorMessage name="zip" />
              </div>

              {this.props.requiredSSN ? (
                <div className="form-group">
                  <Label htmlFor="ssn">SSN (last 4 digits)</Label>

                  <MaskedField mask="9999" className="form-control" placeholder="ex. 1234" name="ssn" />
                  <ErrorMessage name="ssn" />
                </div>
              ) : null}
              {serverErrorDiv}
              {spinner}
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}
